export default __webpack_public_path__ + "static/media/calendar.7d303477.webp";